module.exports = {
    REQUEST_SPECIALISTS: 'REQUEST_SPECIALISTS',
    RECEIVE_SPECIALISTS: 'RECEIVE_SPECIALISTS',
    REQUEST_SPECIALISTS_FAILURE: 'REQUEST_SPECIALISTS_FAILURE',
    CLEAR_SPECIALISTS: 'CLEAR_SPECIALISTS',
    CLEAR_POSTAL_CODE: 'CLEAR_POSTAL_CODE',
    SET_MY_SPECIALIST_REQUEST: 'SET_MY_SPECIALIST_REQUEST',
    SET_MY_SPECIALIST_SUCCESS: 'SET_MY_SPECIALIST_SUCCESS',
    SET_MY_SPECIALIST_FAILURE: 'SET_MY_SPECIALIST_FAILURE',
    SET_MY_SPECIALIST_PRACTICE: 'SET_MY_SPECIALIST_PRACTICE',
    SET_SPECIALIST_PENDING_ACTION: 'SET_SPECIALIST_PENDING_ACTION',
    REMOVE_SPECIALIST_PENDING_ACTION: 'REMOVE_SPECIALIST_PENDING_ACTION',
    CLEAR_SPECIALISTS_ERROR: 'CLEAR_SPECIALISTS_ERROR'
};



// WEBPACK FOOTER //
// ./src/common/modules/specialists/constants.js